Swal = require('sweetalert2')

$(function () {
    $("body").on("click", ".delete", function (e) {
        e.stopPropagation();
        const url = $(this).data('href');
        const model = $(this).data('model');
        Swal.fire({
            title: 'Remove '+ model,
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#0E7490',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                $.ajax({
                    url: url,
                    method: 'DELETE',
                    success: function () {
                        Swal.fire({
                            title: 'Removed',
                            text: "Has been removed successfully",
                            icon: 'success',
                            confirmButtonColor: '#0E7490',
                            willClose: () => {
                                window.location.reload();
                            }
                        })
                    },
                    error: function (){
                        Swal.fire({
                            title: 'Error',
                            text: "An error occurred, try again later, please.",
                            icon: 'error',
                            confirmButtonColor: '#0E7490',
                        })
                    }
                })
            } else {
                Swal.fire({
                    title: 'No Removed',
                    text: 'The action has been canceled',
                    icon: 'info',
                    confirmButtonColor: '#0E7490',
                })
            }
        })
    });

    $("body").on("click", ".sendpass", function (e) {
        e.stopPropagation();
        const url = $(this).data('href');
        const model = $(this).data('model');
        Swal.fire({
            title: 'Reset Password Link',
            text: "Do you want to send reset link?",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#0E7490',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                $.ajax({
                    url: url,
                    method: 'POST',
                    success: function () {
                        Swal.fire({
                            title: 'Send',
                            text: "the link has been sent",
                            icon: 'success',
                            confirmButtonColor: '#0E7490',
                            willClose: () => {
                                window.location.reload();
                            }
                        })
                    },
                    error: function (){
                        Swal.fire({
                            title: 'Error',
                            text: "An error occurred, try again later, please.",
                            icon: 'error',
                            confirmButtonColor: '#0E7490',
                        })
                    }
                })
            } else {
                Swal.fire({
                    title: 'No Send',
                    text: 'The action has been canceled',
                    icon: 'info',
                    confirmButtonColor: '#0E7490',
                })
            }
        })
    });

    $("body").on("click", ".sendwelcome", function (e) {
        e.stopPropagation();
        const url = $(this).data('href');
        const model = $(this).data('model');
        Swal.fire({
            title: 'Send welcome email',
            text: "Do you want to send welcome email?",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#0E7490',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                $.ajax({
                    url: url,
                    method: 'POST',
                    success: function () {
                        Swal.fire({
                            title: 'Send',
                            text: "the welcome email has been sent",
                            icon: 'success',
                            confirmButtonColor: '#0E7490',
                            willClose: () => {
                                window.location.reload();
                            }
                        })
                    },
                    error: function (){
                        Swal.fire({
                            title: 'Error',
                            text: "An error occurred, try again later, please.",
                            icon: 'error',
                            confirmButtonColor: '#0E7490',
                        })
                    }
                })
            } else {
                Swal.fire({
                    title: 'No Send',
                    text: 'The action has been canceled',
                    icon: 'info',
                    confirmButtonColor: '#0E7490',
                })
            }
        })
    });

    $("body").on("click", ".duplicate", function (e) {
        e.stopPropagation();
        const url = $(this).data('href');
        const model = $(this).data('model');
        Swal.fire({
            title: 'Duplicate Program',
            text: "Do you want to duplicate this program?",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#0E7490',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                $.ajax({
                    url: url,
                    method: 'POST',
                    success: function () {
                        Swal.fire({
                            title: 'Duplicated',
                            text: "the program has been duplicated",
                            icon: 'success',
                            confirmButtonColor: '#0E7490',
                            willClose: () => {
                                window.location.reload();
                            }
                        })
                    },
                    error: function (){
                        Swal.fire({
                            title: 'Error',
                            text: "An error occurred, try again later, please.",
                            icon: 'error',
                            confirmButtonColor: '#0E7490',
                        })
                    }
                })
            } else {
                Swal.fire({
                    title: 'No Duplicated',
                    text: 'The action has been canceled',
                    icon: 'info',
                    confirmButtonColor: '#0E7490',
                })
            }
        })
    });

});
